// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2xpjq","alert":"SettungsInbox_alert__1Y-dM"};